import type { GridRowSelectionModel } from '@mui/x-data-grid-pro';
import type { SiteMeta } from '@src/types/SiteMeta';
import type { WidgetTypeDeviceList } from '@src/types/Widget';
import type { TimeMode } from '@types';

export const TEMPERATURE_THRESHOLDS = {
  INCIDENT: 40,
  CRITICAL: 50,
} as const;

export enum DataSource {
  MQTT = 'mqtt',
  ALERTS = 'alerts',
}

export enum ConnectionStatus {
  CONNECTED = 'connected',
  DISCONNECTED = 'disconnected',
  RECONNECTING = 'reconnecting',
}

export interface Incident {
  readonly id: string;
  deviceName: string;
  rackId: string;
  maxCellT: number;
  timestamp: string;
  unitId: string;
  isRealTime?: boolean;
  dataSource?: DataSource;
  mqttTopic?: string;
}

export interface IncidentMaxCellTMonitorProps {
  widgetConfig?: WidgetTypeDeviceList;
  selectedUnits?: GridRowSelectionModel;
  siteMeta: SiteMeta;
  timeMode: TimeMode;
}
